import { render, staticRenderFns } from "./CBGS.vue?vue&type=template&id=15e6e217&"
import script from "./CBGS.vue?vue&type=script&lang=js&"
export * from "./CBGS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports